import React from 'react';
import { PadCommand } from '../../types';
import { getIcon } from '../../utils/getIcon';

interface PadProps {
  id: number;
  value: PadCommand;
  isActive: boolean;
  isSelected: boolean;
  nudgeValue: number;
  onClick: () => void;
}

const Pad: React.FC<PadProps> = ({ id, value, isActive, isSelected, nudgeValue, onClick }) => {
  const hasCommand = value !== PadCommand.EMPTY;

  return (
    <div
      className={`pad ${isActive ? 'active' : ''} ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      style={{
        aspectRatio: '1',
        backgroundColor: isActive ? 'var(--accent)' : hasCommand ? 'var(--bg-tertiary)' : 'var(--bg-secondary)',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        border: isSelected ? '2px solid var(--accent)' : '1px solid var(--border-color)',
        transition: 'background-color 0.1s ease',
      }}
    >
      {/* Command icon */}
      <div style={{
        fontSize: '0.75rem',
        color: isActive ? '#000' : 'var(--text-primary)',
        fontWeight: 600
      }}>
        {hasCommand && getIcon(value)}
      </div>
      {/* id number */}
      <span style={{
        position: 'absolute',
        top: '1px',
        left: '2px',
        fontSize: '8px',
        color: isActive ? '#000' : 'var(--text-muted)',
        userSelect: 'none',
        lineHeight: 1
      }}>
        {id + 1}
      </span>
      {/* Nudge indicator */}
      {nudgeValue !== 0 && (
        <div style={{
          position: 'absolute',
          bottom: '1px',
          left: '50%',
          transform: `translateX(${nudgeValue < 0 ? '-100%' : '0%'})`,
          width: `${Math.min(Math.abs(nudgeValue * 50), 50)}%`,
          height: '2px',
          backgroundColor: 'var(--accent)',
        }} />
      )}
    </div>
  );
};

export default Pad;
